import React, { useEffect } from 'react';
import './App.css';
import { LandingPage } from './components/landing_page/landing_page';
import { HashRouter, Route, Switch } from 'react-router-dom'
import { RestProvider } from './contexts/rest/provider'
import { ConfigProvider } from './contexts/config/provider'
import { QueueDisplay } from './components/queue_selection_page/queue_display';
import { TicketPage } from './components/ticketinfo_page/ticketpage'
import { MaterialThemeProvider } from './contexts/theme/provider';
import { TranslationProvider } from './contexts/i18n/provider';
import { MissingPage } from './components/missingpage'
import { FormsPage } from './components/forms_page/formspage';

function App() {

  useEffect(() => {
      const handleWindowResize = () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      }

      window.scrollTo(0,1);
      handleWindowResize();
      window.addEventListener('resize', handleWindowResize);

      return () => window.removeEventListener('resize', handleWindowResize);
  },[])

    return (
    <HashRouter>
      <div className="App" >
        <ConfigProvider>
          <RestProvider>
            <MaterialThemeProvider>
              <TranslationProvider>
                <Switch>
                  <Route path="/queues">
                    <QueueDisplay />
                  </Route>
                  <Route path="/forms">
                    <FormsPage />
                  </Route>
                  <Route path="/ticket">
                    <TicketPage />
                  </Route>
                  <Route path="/404">
                    <MissingPage />  
                  </Route>   
                  <Route path="/">
                    <LandingPage />
                  </Route>
                </Switch>
              </TranslationProvider>
            </MaterialThemeProvider>
          </RestProvider>
        </ConfigProvider>
      </div>
    </HashRouter>
  );
}

export default App;
